import GradeHistoryTable from '../../tables/GradeHistoryTable';
import MaturityHistoryTable from '../../tables/MaturityHistoryTable';
import DrawFundingHistoryTable from '../../tables/DrawFundingHistoryTable';
import IssuesPopupTables from '../../tables/IssuesPopupTables';
import EntityLoansTable from '../../tables/EntityLoansTable';
import LiquidityHistoryTable from '../../tables/LiquidityHistoryTable';
import AppraisalHistoryTable from '../../tables/AppraisalHistoryTable';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { WatchlistPopupType } from '../WatchlistConstants';

export const WatchlistPopupDialog = ({ isOpen, title, type, loanId, propertyId, entityId, watchlistId, onClose }) => {
    if (!isOpen || !type || (!loanId && !propertyId) || !entityId || !watchlistId) {
        return;
    }

    const styles = {
        buttonMarginRight: { marginRight: '10px' },
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
    };

    const onCancelClick = () => {
        onClose && onClose();
    };

    const getWidth = () => {
        switch (type) {
            case 2:
                return '400px';
            case 4:
            case 6:
                return '550px';
            default:
                return '700px';
        }
    };

    return (
        <Dialog
            maxWidth='md'
            open={isOpen}
            onClose={onCancelClick}
            aria-labelledby='form-dialog-title'
        >
            <DialogContent>
                <div className='modal-container'>
                    <div className='modal-backdrop'></div>
                    <div
                        className='modal'
                        tabIndex='-1'
                        role='dialog'
                        style={{ width: getWidth() }}
                    >
                        <div
                            className='modal-dialog'
                            role='document'
                        >
                            <div
                                className='page-header'
                                role='banner'
                            >
                                <h1 style={{ whiteSpace: 'nowrap' }}>{title}</h1>
                                <button
                                    type='button'
                                    className='close'
                                    data-dismiss='modal'
                                    aria-label='Close'
                                    onClick={onCancelClick}
                                >
                                    <span aria-hidden='true'>&times;</span>
                                </button>
                            </div>
                            <div
                                className='main-content no-search'
                                style={{ padding: '10px', width: '100%' }}
                            >
                                {type === WatchlistPopupType.GradeHistory && loanId > 0 && <GradeHistoryTable loanId={loanId} />}
                                {type === WatchlistPopupType.MaturityHistory && loanId > 0 && (
                                    <MaturityHistoryTable loanId={loanId} />
                                )}
                                {type === WatchlistPopupType.Issues && loanId > 0 && !propertyId && watchlistId > 0 && (
                                    <IssuesPopupTables
                                        watchlistId={watchlistId}
                                        loanId={loanId}
                                    />
                                )}
                                {type === WatchlistPopupType.Issues && propertyId > 0 && watchlistId > 0 && (
                                    <IssuesPopupTables
                                        watchlistId={watchlistId}
                                        propertyId={propertyId}
                                    />
                                )}
                                {type === WatchlistPopupType.FundingHistory && loanId > 0 && watchlistId > 0 && (
                                    <DrawFundingHistoryTable loanId={loanId} />
                                )}
                                {type === WatchlistPopupType.EntityLoans && entityId > 0 && watchlistId > 0 && (
                                    <EntityLoansTable
                                        watchlistId={watchlistId}
                                        entityId={entityId}
                                    />
                                )}
                                {type === WatchlistPopupType.LiquidityHistory && loanId > 0 && (
                                    <LiquidityHistoryTable loanId={loanId} />
                                )}
                                {type === WatchlistPopupType.AppraisalsHistory && loanId > 0 && !propertyId && (
                                    <AppraisalHistoryTable loanId={loanId} />
                                )}
                                {type === WatchlistPopupType.AppraisalsHistory && propertyId > 0 && (
                                    <AppraisalHistoryTable propertyId={propertyId} />
                                )}
                            </div>
                            <div
                                className='button-footer'
                                style={styles.buttonContainer}
                            >
                                <button
                                    type='button'
                                    className='button primary'
                                    onClick={onCancelClick}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
